import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@coin/shared/core/util-environments';
import { Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoadingService } from '@coin/shared/core/data-access';
import { BudgetAllocationOverviewDto } from '../models/budget-allocation-overview.model';
import { MeritAllocationImpersonatedEmployeeService } from './merit-allocation-impersonated-employee.service';

@Injectable({
  providedIn: 'root'
})
export class MeritTotalResponsibilityService {
  private httpClient = inject(HttpClient);
  private loadingService = inject(LoadingService);
  private meritAllocationImpersonatedEmployeeService = inject(MeritAllocationImpersonatedEmployeeService);

  getBudgetOverview(seasonId: string, employeeId: string, orgCode: string): Observable<BudgetAllocationOverviewDto> {
    this.loadingService.present();
    return this.httpClient
      .get<BudgetAllocationOverviewDto>(
        `${environment.api.baseUrl}/admin/api/v2/master/seasons/merit/${seasonId}/allocations/total/overview/${employeeId}?orgCode=${encodeURIComponent(
          orgCode
        )}${this.meritAllocationImpersonatedEmployeeService.getEmployeeIdQuery()}`
      )
      .pipe(
        catchError(() => of(null)),
        finalize(() => this.loadingService.dismiss())
      );
  }
}
